import {Component, Injector, Input, OnDestroy, OnInit} from '@angular/core';
import {takeUntil} from 'rxjs/operators';
import {BaseDialogTemplateComponent} from '../base-dialog-template.component';
import {PaginationCallbackFunction} from '../../../../../shared/components/list/list.component';
import {PAGINATION_DEFAULT_PAGE_SIZE} from '../../../../../shared/components/list/pagination.component';
import {DefibrillatorTest} from '../../../../../shared/models/defibrillatorTest.model';
import {VisualizationMode} from '../../../../../shared/enums/visualization-mode.enum';
import {Panel} from '../../../../../shared/models/visualization/panel.model';
import {DefibrillatorDialogComponent} from './dialog/defibrillator-dialog.component';
import {HealthCase} from '../../../../../shared/models/healthCase.model';
import {ContextService} from '../../../../../core/services/http/context.service';
import {DefibrillatorEkgDialogComponent} from './dialog/defibrillator-ekgdialog.component';
import {DateSelectionDialogComponent} from 'app/modules/dialog/date-selection-dialog/date-selection-dialog.component';
import {EventService} from 'app/core/services/event.service';
import {UrukTemporalQuery} from 'app/shared/models/query/uruk-temporal-query.model';
import {DefibrillatorService} from 'app/core/services/defibrillator.service';
import {DefibrillatorProperty, DefibrillatorUpdatedData} from 'app/shared/models/defibrillatorUpdatedData.model';
import {UserService} from '../../../../../core/services/data/user.service';
import {
  GenericConfirmationDialogComponent
} from '../../../../dialog/confirmation-dialog/generic-confirmation-dialog.component';
import {NbGlobalPhysicalPosition, NbToastrService} from '@nebular/theme';
import {AnimationOptions} from 'ngx-lottie';

@Component({
  selector: 'defibrillator-template',
  templateUrl: './defibrillator-template.component.html',
  styleUrls: ['./defibrillator-template.component.scss']
})

export class DefibrillatorTemplateComponent extends BaseDialogTemplateComponent implements OnInit, OnDestroy {
  @Input() cBrokerEndpoint: string;
  @Input() dataRealmId: string;
  cbrokerService: ContextService;
  private toastService: NbToastrService;
  userService: UserService;
  // the list of defibrillator retrieved from server
  defibrillatorTests: DefibrillatorTest[] = [];
  // paginated sensors displayed in the list view
  paginatedDefibrillatorTests: DefibrillatorTest[] = [];
  paginatedHealthCases: HealthCase[] = [];
  healthCases: HealthCase[] = [];
  DEFAULT_ICON = 'assets/images/location-source-gsm.png';
  LOCATION_ICONS: Record<number, string> = {
    1: 'assets/images/location-source-gps.png',
    2: 'assets/images/location-source-wifi.png',
  };
  entity: any;

  positionEntity: any;

  subEntities: any;

  healthCasesEntities: any;

  Defibrillator: any;

  defibrillatorId: string;

  defibrillatorLocation: string;

  defibrillatorService: DefibrillatorService;

  AEDDeviceModel: number;

  AEDDeviceLCD: number;

  AEDSerialNumber: string;

  batterySerialNumber: string;

  hardwareRevisionNumber: string;

  softwareRevisionNumber: string;

  primaryLanguagePack: string;

  secondaryLanguagePack: string;

  simOperatorName: string;

  simTelNo: string;

  aedDeviceAdultShockEnergySteps: string;

  aedDevicePediatricShockEnergySteps: string;

  aedDeviceEnergyRetentionTime: number;

  aedDevicePeriodicTestInterval: number;

  aedDeviceShockProtocol: number;

  aedDeviceSoundLevel: number;

  iotModuleSerialNumber: string;

  iotModuleSoftwareRevisionNumber: string;

  iotModuleHardwareRevisionNumber: string;

  iotGsmConnectionType: number;

  iotAccelerometerTestResult: number;

  iotInternalMemoryTestResult: number;

  iotGsmSignalQualityLte: number;

  iotAedConnectionTestResult: number;

  iotGsmSignalQuality2G: number;

  adultPadExpirationDate: string;
  initialAdultPadExpirationDate: string;
  adultPadExpirationDateDeleted: boolean = false;

  pediatricPadExpirationDate: string;
  initialPediatricPadExpirationDate: string;
  pediatricPadExpirationDateDeleted: boolean = false;

  guaranteeStartDate: string;
  initialGuaranteeStartDate: string;
  guaranteeStartDateDeleted: boolean = false;

  adultTempQuery: UrukTemporalQuery;

  pediatricTempQuery: UrukTemporalQuery;

  guaranteeTempQuery: UrukTemporalQuery;

  description: string;
  initialDescription: string;

  initialCompanyName: string;
  companyName: string = '';
  companyNameOptions = [];

  showFooter: boolean = true;

  activeTab: string = 'summary';

  dialogViewportMin: number;

  casePanel: Panel;

  PANEL_LOCATION_CASE = 'case';

  testTypeMap: string[] = ['defibrillator-test-24-days', 'defibrillator-test-6-month', 'defibrillator-test-manual'];

  VisualizationMode = VisualizationMode;

  defibrillatorStatus: string;
  defibrillatorStatusMessage: string;

  isBatteryErrorAED: boolean;

  connectionTypeName: string;

  signalQuality: string;

  lastUpdateTime: string;

  signalQualityIcon: string;

  chargedBatteryIcon: string = 'assets/images/battery.png';
  locationIcon = this.DEFAULT_ICON;

  colorSignalQuality: string;

  isLastTestTimeNotValid: boolean = true;

  showTestError: boolean = false;
  isFullAutomaticDisplay: boolean = false;
  isHalfAutomaticDisplay: boolean = false;
  isFullAutomaticNonDisplay: boolean = false;
  isHalfAutomaticNonDisplay: boolean = false;
  positionStatus: number;
  showSignalQuality: boolean = true;
  isVisibleHealthCaseTab: boolean = false;
  isRegularUser: boolean = false;

  accelerometerStatus: boolean;
  initialAccelerometerStatus: boolean;
  calendarPlaceHolder: string = '00/00/0000';
  updateButtonStatus: string = 'passive';
  cancelButtonStatus: string = 'passive';

  apnName: string;
  apnUsername: string;
  apnPasswordTouched: boolean = false;
  apnPassword: string = '';
  apnPasswordVerification: string = '';
  initialApnName: string;
  initialApnUsername: string;
  initialApnPassword: string = '';
  initialApnPasswordVerification: string = '';
  initialSimTelNo: string;
  showApnPassword: boolean = false;
  showApnPasswordVerification: boolean = false;
  updateApnButtonStatus: string = 'passive';
  cancelApnButtonStatus: string = 'passive';
  displayErrors: boolean = false;
  errors: { [key: string]: string } = {
    passwordError: '',
  };
  source: string = '';

  lottieOptions: AnimationOptions = {
    path: '/assets/animation/uruk-5sec.json',
  };

  private pageSize = PAGINATION_DEFAULT_PAGE_SIZE;

  private defibrillatorPage = 1;

  public paginationCallback: PaginationCallbackFunction;
  signalQualityMap: string[] = ['defibrillator-critical-signal', 'defibrillator-low-signal', 'defibrillator-normal-signal', 'defibrillator-good-signal'];
  loading: boolean = true;

  constructor(injector: Injector) {
    super(injector);
    this.cbrokerService = injector.get(ContextService);
    this.defibrillatorService = injector.get(DefibrillatorService);
    this.userService = injector.get(UserService);
    this.toastService = injector.get(NbToastrService);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.defibrillatorService.getUserAttributes(this.dataRealmId).subscribe(companyInfos => {
      this.companyNameOptions = companyInfos;
      this.setCompanyNameFromEntity();
    });
    this.paginationCallback = this.setPaginatedSensors.bind(this);
    this.dialogViewportMin = Math.min(this.layoutService.getApplicationSize()[0], this.layoutService.getApplicationSize()[1]) / 4;
    this.handleEventSubscriptions();
    this.isRegularUser = this.userService.isRegularUser();
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  public onTabChange(event) {
    this.activeTab = event.tabId;
  }

  handleEventSubscriptions() {
    this.eventService.eventEmitter
      .pipe(takeUntil(this.destroy$))
      .subscribe(event => {
        switch (event.id) {
          case EventService.TIME_CHANGED:
            if (event.data.timeQuery.displayText === 'Today') {
              const now = new Date();
              const day = String(now.getDate()).padStart(2, '0');
              const month = String(now.getMonth() + 1).padStart(2, '0');
              const year = now.getFullYear();
              event.data.timeQuery.displayText = `${day}/${month}/${year}`;
            }
            if (event.data.dialogSource === 'adult') {
              this.adultTempQuery = event.data.timeQuery;
            } else if (event.data.dialogSource === 'pediatric') {
              this.pediatricTempQuery = event.data.timeQuery;
            } else {
              this.guaranteeTempQuery = event.data.timeQuery;
            }
            this.activateUpdateButton();
            break;
          default:
            break;
        }
      });
  }

  mapPanels(): void {
    this.page?.panels.forEach(panel => {
      panel.ngsiContext.idQuery = this.entity.id;
      switch (panel.panelLocation) {
        case this.PANEL_LOCATION_CASE:
          this.casePanel = panel;
          break;
      }
    });
  }

  protected mapContextData(context: any): void {
    this.entity = context.entity.result ? context.entity.result.entity[0] : undefined;
    this.positionEntity = context.positionEntity.result.entity;
    this.subEntities = context.subEntities ? context.subEntities.results : undefined;
    this.healthCasesEntities = context.healthCases.result.entity;
    this.isVisibleHealthCaseTab = this.healthCasesEntities.length > 0;
    this.isBatteryErrorAED = false;

    this.subEntities.sort(this.compareByTestDate);

    for (let i = 0; i < this.subEntities.length; i++) {
      this.defibrillatorTests.push(new DefibrillatorTest({
        IOTModuleBatteryVoltageLevel: this.subEntities[i].result.entity.IOTModuleBatteryVoltageLevel.value / 10,
        AEDDeviceBatteryVoltageLevel: this.subEntities[i].result.entity.AEDDeviceBatteryVoltageLevel.value / 10,
        testDay: this.subEntities[i].result.entity.testDay.value,
        testMonth: this.subEntities[i].result.entity.testMonth.value,
        testYear: this.subEntities[i].result.entity.testYear.value + 2000,
        testHour: this.subEntities[i].result.entity.testHour.value,
        testMinute: this.subEntities[i].result.entity.testMinute.value,
        testType: this.calculateTestType(this.subEntities[i].result.entity.testType.value),
        adsTestResult: this.subEntities[i].result.entity.adsTestResult.value,
        ecgTestResult: this.subEntities[i].result.entity.ecgTestResult.value,
        cryptoTestResult: this.subEntities[i].result.entity.cryptoTestResult.value,
        audioTestResult: this.subEntities[i].result.entity.audioTestResult.value,
        padTestResult: this.subEntities[i].result.entity.padTestResult.value,
        chargeCircuit1TestResult: this.subEntities[i].result.entity.chargeCircuit1TestResult.value,
        chargeCircuit2TestResult: this.subEntities[i].result.entity.chargeCircuit2TestResult.value,
        capacitorVoltageTestResult: this.subEntities[i].result.entity.capacitorVoltageTestResult.value,
        hBridgeCircuit1TestResult: this.subEntities[i].result.entity.hBridgeCircuit1TestResult.value,
        hBridgeCircuit2TestResult: this.subEntities[i].result.entity.hBridgeCircuit2TestResult.value,
        onOffButtonTestResult: this.subEntities[i].result.entity.onOffButtonTestResult.value,
        shockButtonTestResult: this.subEntities[i].result.entity.shockButtonTestResult.value,
        iotGsmConnectionType: this.subEntities[i].result.entity.iotGsmConnectionType ? this.subEntities[i].result.entity.iotGsmConnectionType.value : '',
        iotAccelerometerTestResult: this.subEntities[i].result.entity.iotAccelerometerTestResult ? this.subEntities[i].result.entity.iotAccelerometerTestResult.value : '',
        iotInternalMemoryTestResult: this.subEntities[i].result.entity.iotInternalMemoryTestResult ? this.subEntities[i].result.entity.iotInternalMemoryTestResult.value : '',
        iotGsmSignalQualityLte: this.subEntities[i].result.entity.iotGsmSignalQualityLte ? this.subEntities[i].result.entity.iotGsmSignalQualityLte.value : '',
        iotAedConnectionTestResult: this.subEntities[i].result.entity.iotAedConnectionTestResult ? this.subEntities[i].result.entity.iotAedConnectionTestResult.value : '',
        iotGsmSignalQuality2G: this.subEntities[i].result.entity.iotGsmSignalQuality2G ? this.subEntities[i].result.entity.iotGsmSignalQuality2G.value : '',
        colorIOTModuleBatteryVoltageLevel: this.checkIOTBatteryColor(this.subEntities[i].result.entity.IOTModuleBatteryVoltageLevel.value / 10, i),
        colorAEDDeviceBatteryVoltageLevel: this.checkAEDBatteryColor(this.subEntities[i].result.entity.AEDDeviceBatteryVoltageLevel.value / 10, i),
        testResult: this.checkAllTest(this.subEntities[i].result.entity),
        colorADSTestResult: this.checkTestResultColor(this.subEntities[i].result.entity.adsTestResult.value),
        colorECGTestResult: this.checkTestResultColor(this.subEntities[i].result.entity.ecgTestResult.value),
        colorTestResult: this.checkAllTestColor(this.checkAllTest(this.subEntities[i].result.entity), this.subEntities[i].result.entity.padTestResult.value),
        ads4v6Result: this.subEntities[i].result.entity?.ads4v6Result?.value,
        dacSetVoltage: this.subEntities[i].result.entity?.dacSetVoltage?.value,
        chargingVoltage: this.subEntities[i].result.entity?.chargingVoltage?.value,
        chargeTime: this.subEntities[i].result.entity?.chargeTime?.value,
        hBridge1: this.subEntities[i].result.entity?.hBridge1?.value,
        hBridge2: this.subEntities[i].result.entity?.hBridge2?.value
      }));
    }
    this.defibrillatorTests.sort(this.compareByTestDate);


    this.defibrillatorId = super.getValue(this.entity, 'id').split(':')[3];
    this.defibrillatorLocation = this.positionEntity.location.value.coordinates;
    this.AEDDeviceModel = this.entity.AEDDeviceModel.value;
    this.AEDDeviceLCD = this.entity.AEDDeviceLCD.value;
    this.AEDSerialNumber = this.entity.AEDSerialNumber.value;
    this.batterySerialNumber = this.entity.batterySerialNumber ? this.entity.batterySerialNumber.value : '';
    this.hardwareRevisionNumber = this.entity.hasOwnProperty('hardwareRevisionNumber') ? this.entity.hardwareRevisionNumber.value : '';
    this.softwareRevisionNumber = this.entity.hasOwnProperty('softwareRevisionNumber') ? this.entity.softwareRevisionNumber.value : '';
    this.primaryLanguagePack = this.entity.primaryLanguagePack ? this.entity.primaryLanguagePack.value : '';
    this.secondaryLanguagePack = this.entity.secondaryLanguagePack ? this.entity.secondaryLanguagePack.value : '';
    this.simOperatorName = this.entity.simOperatorName ? this.entity.simOperatorName.value : '-';
    this.initialSimTelNo = this.simTelNo = this.entity.simTelNo ? this.entity.simTelNo.value : '-';
    this.aedDeviceAdultShockEnergySteps = this.entity.aedDeviceAdultShockEnergySteps ? this.entity.aedDeviceAdultShockEnergySteps.value : '';
    this.aedDevicePediatricShockEnergySteps = this.entity.aedDevicePediatricShockEnergySteps ? this.entity.aedDevicePediatricShockEnergySteps.value : '';
    this.aedDeviceEnergyRetentionTime = this.entity.aedDeviceEnergyRetentionTime ? this.entity.aedDeviceEnergyRetentionTime.value : '';
    this.aedDevicePeriodicTestInterval = this.entity.aedDevicePeriodicTestInterval ? this.entity.aedDevicePeriodicTestInterval.value : '';
    this.aedDeviceShockProtocol = this.entity.aedDevicePeriodicTestInterval ? this.entity.aedDeviceShockProtocol.value : '';
    this.aedDeviceSoundLevel = this.entity.aedDeviceSoundLevel ? this.entity.aedDeviceSoundLevel.value : '';
    this.iotModuleSerialNumber = this.entity.iotModuleSerialNumber ? this.entity.iotModuleSerialNumber.value : '';
    this.iotModuleSoftwareRevisionNumber = this.entity.iotModuleSoftwareRevisionNumber ? this.entity.iotModuleSoftwareRevisionNumber.value : '';
    this.iotModuleHardwareRevisionNumber = this.entity.iotModuleHardwareRevisionNumber ? this.entity.iotModuleHardwareRevisionNumber.value : '';
    this.adultPadExpirationDate = this.entity.adultPadExpirationDate ? this.entity.adultPadExpirationDate.value : undefined;
    this.initialAdultPadExpirationDate = this.adultPadExpirationDate;
    this.pediatricPadExpirationDate = this.entity.pediatricPadExpirationDate ? this.entity.pediatricPadExpirationDate.value : undefined;
    this.initialPediatricPadExpirationDate = this.pediatricPadExpirationDate;
    this.guaranteeStartDate = this.entity.guaranteeStartDate ? this.entity.guaranteeStartDate.value : undefined;
    this.initialGuaranteeStartDate = this.guaranteeStartDate;
    this.setCompanyNameFromEntity();
    this.initialAccelerometerStatus = this.accelerometerStatus = this.entity.accelerometerStatus ? this.entity.accelerometerStatus.value : null;
    this.description = this.entity.description ? this.entity.description.value : undefined;
    this.initialDescription = this.description;
    const date: Date = new Date(this.entity.iotModuleSerialNumber.observedAt);
    this.initialApnName = this.apnName = this.entity.apnName ? this.entity.apnName.value : '';
    this.initialApnUsername = this.apnUsername = this.entity.apnUser ? this.entity.apnUser.value : '';
    this.initialApnPassword = this.apnPassword = this.entity.apnPassword ? this.entity.apnPassword.value : '';
    const pad = (n: number) => n.toString().padStart(2, '0');
    this.lastUpdateTime = this.entity.iotModuleSerialNumber
      ? `${pad(date.getDate())}.${pad(date.getMonth() + 1)}.${date.getFullYear()} ${pad(date.getHours())}:${pad(date.getMinutes())}`
      : '-';
    this.locationIcon = this.positionEntity.locationState ? this.LOCATION_ICONS[this.positionEntity.locationState.value] ?? this.DEFAULT_ICON : this.DEFAULT_ICON;
    this.source = this.entity.source ? this.entity.source.value : this.authService.getRealmId();
    if (this.AEDDeviceModel === 0 && this.AEDDeviceLCD === 0) {
      this.isHalfAutomaticNonDisplay = true;
    } else if (this.AEDDeviceModel === 0 && this.AEDDeviceLCD === 1) {
      this.isHalfAutomaticDisplay = true;
    } else if (this.AEDDeviceModel === 1 && this.AEDDeviceLCD === 0) {
      this.isFullAutomaticNonDisplay = true;
    } else {
      this.isFullAutomaticDisplay = true;
    }

    this.positionStatus = this.positionEntity.status ? this.positionEntity.status.value : -1;

    for (let i = 0; i < this.healthCasesEntities.length; i++) {
      this.healthCases.push(new HealthCase({
        healthCaseId: this.getHealthCaseId(this.healthCasesEntities[i].id),
        caseDate: this.getCaseDate(this.healthCasesEntities[i].refId.observedAt),
        caseHour: this.getCaseTime(this.healthCasesEntities[i].refId.observedAt),
        observedAt: this.healthCasesEntities[i].refId.observedAt
      }));
    }

    this.paginatedDefibrillatorTests = this.defibrillatorTests.slice(0, this.defibrillatorTests.length);
    this.paginatedHealthCases = this.healthCases.slice(0, this.healthCases.length);

    if (this.defibrillatorTests.length > 0) {
      this.checkLastTestDate(this.defibrillatorTests[0].testDay, this.defibrillatorTests[0].testMonth,
        this.defibrillatorTests[0].testYear, this.defibrillatorTests[0].testHour,
        this.defibrillatorTests[0].testMinute);

      if (this.positionEntity?.iotGsmConnectionType && (this.positionEntity?.iotGsmSignalQuality2G || this.positionEntity?.iotGsmSignalQualityLte)) {
        if (this.positionEntity.iotGsmConnectionType.observedAt > this.subEntities[0].result.entity.iotGsmConnectionType.observedAt) {
          this.checkConnectionStatusType(this.positionEntity.iotGsmConnectionType.value, this.positionEntity.iotGsmSignalQualityLte.value, this.positionEntity.iotGsmSignalQuality2G.value);
        } else {
          this.checkConnectionStatusType(this.defibrillatorTests[0].iotGsmConnectionType,
            this.defibrillatorTests[0].iotGsmSignalQualityLte, this.defibrillatorTests[0].iotGsmSignalQuality2G);
        }
      }

      this.checkDefibrillatorStatus(this.defibrillatorTests[0].testResult,
        this.defibrillatorTests[0].padTestResult, this.defibrillatorTests[0].AEDDeviceBatteryVoltageLevel, this.defibrillatorTests[0].IOTModuleBatteryVoltageLevel);

      this.showTestError = this.defibrillatorTests[0].testResult !== 1;
    }
    this.loading = false;
  }

  private setCompanyNameFromEntity(): void {
    this.initialCompanyName = this.companyName = this.entity?.companyName ? this.findCompanyByName(this.entity.companyName.value) : '-';
  }

  private findCompanyByName(companyName: string): string | undefined {
    return this.companyNameOptions.find(company => {
      // tslint:disable-next-line:prefer-const
      let [id, name] = company.split('-');
      return name === companyName;
    });
  }

  getCompanyName(): string {
    if (this.companyName && this.companyName.length > 1) {
      return this.companyName.split('-')[1];
    }
    return '-';
  }

  private setPaginatedSensors(pageSize = PAGINATION_DEFAULT_PAGE_SIZE, page = 1) {
    this.pageSize = pageSize;
    this.defibrillatorPage = page;
    // @ts-ignore
    this.paginatedDefibrillatorTests = this.sensors.slice(this.pageSize * (this.mgubPage - 1), this.pageSize * this.mgubPage);
  }

  private compareByTestDate(a, b) {
    const dateA = new Date(a.testYear, a.testMonth - 1,
      a.testDay, a.testHour, a.testMinute);
    const dateB = new Date(b.testYear, b.testMonth - 1,
      b.testDay, b.testHour, b.testMinute);
    return dateB.getTime() - dateA.getTime();
  }

  private checkAEDBatteryColor(batteryLevel: number, index: number) {
    if (batteryLevel >= 10) {
      return 'green';
    } else if (batteryLevel >= 9.5) {
      return 'yellow';
    } else {
      if (index === 0) {
        this.isBatteryErrorAED = true;
      }
      return 'red';
    }
  }

  private checkIOTBatteryColor(batteryLevel: number, index: number) {
    if (batteryLevel >= 2.65) {
      return 'green';
    } else {
      return 'yellow';
    }
  }

  private checkTestResultColor(testResult) {
    if (testResult === 0) {
      return 'red';
    } else {
      return 'green';
    }
  }

  private checkDefibrillatorStatus(testResult, padValue, aedBatteryVoltage, iotBatteryVoltageLevel) {

    if (this.positionStatus === 2) {
      this.defibrillatorStatus = 'used';
    } else if (this.isLastTestTimeNotValid) {
      this.defibrillatorStatus = 'notconnected';
    } else if (testResult === 0 || aedBatteryVoltage < 9.5) {
      this.defibrillatorStatus = 'error';
    } else if ((aedBatteryVoltage >= 9.5 && aedBatteryVoltage < 10) || iotBatteryVoltageLevel < 2.65) {
      this.defibrillatorStatus = 'lowbattery';
    } else if (padValue === 0) {
      this.defibrillatorStatus = 'pednotengaged';
    } else {
      this.defibrillatorStatus = 'avaliable';
    }

    if (this.positionStatus === 1) {
      this.defibrillatorStatusMessage = this.defibrillatorStatus + '-move';
    } else {
      this.defibrillatorStatusMessage = this.defibrillatorStatus;
    }

  }

  private checkConnectionStatusType(gsmConnectionType, gsmLteQuality, gsm2gQuality) {
    if (gsmConnectionType === 7) {
      this.connectionTypeName = 'LTE';
      this.calculateSignalQualityLTE(gsmLteQuality);
    } else {
      this.connectionTypeName = '2G';
      this.calculateSignalQuality2G(gsm2gQuality);
    }
    this.getSignalQualityIcon(this.signalQuality);
  }

  private calculateSignalQuality2G(gsmSignalQuality) {
    if (gsmSignalQuality === 0) {
      this.signalQuality = this.signalQualityMap[0];
    } else if (gsmSignalQuality === 1) {
      this.signalQuality = this.signalQualityMap[1];
    } else if (gsmSignalQuality === 31) {
      this.signalQuality = this.signalQualityMap[3];
    } else {
      this.signalQuality = this.signalQualityMap[2];
    }
  }

  private calculateSignalQualityLTE(gsmSignalQuality) {
    if (gsmSignalQuality < -100) {
      this.signalQuality = this.signalQualityMap[0];
    } else if (gsmSignalQuality < -90 && gsmSignalQuality >= -100) {
      this.signalQuality = this.signalQualityMap[1];
    } else if (gsmSignalQuality < -80 && gsmSignalQuality >= -90) {
      this.signalQuality = this.signalQualityMap[2];
    } else {
      this.signalQuality = this.signalQualityMap[3];
    }
  }

  private getSignalQualityIcon(signalQuality) {
    if (signalQuality === this.signalQualityMap[0]) {
      this.signalQualityIcon = 'assets/images/critical-signal.png';
      this.colorSignalQuality = 'red';
    } else if (signalQuality === this.signalQualityMap[1]) {
      this.signalQualityIcon = 'assets/images/low-signal.png';
      this.colorSignalQuality = 'yellow';
    } else if (signalQuality === this.signalQualityMap[2]) {
      this.signalQualityIcon = 'assets/images/normal-signal.png';
      this.colorSignalQuality = 'green';
    } else {
      this.signalQualityIcon = 'assets/images/good-signal.png';
      this.colorSignalQuality = 'green';
    }
  }

  private checkAllTest(testEntity) {

    const entity = this.checkTestValue(testEntity);

    if (entity.adsTestResult.value === 0 || entity.ecgTestResult.value === 0 || entity.cryptoTestResult.value === 0 ||
      entity.audioTestResult.value === 0 || entity.iotInternalMemoryTestResult.value === 0 || entity.chargeCircuit1TestResult.value === 0 ||
      entity.chargeCircuit2TestResult.value === 0 || entity.capacitorVoltageTestResult.value === 0 || entity.hBridgeCircuit1TestResult.value === 0 ||
      entity.hBridgeCircuit2TestResult.value === 0 || entity.onOffButtonTestResult.value === 0 || entity.shockButtonTestResult.value === 0 ||
      entity.iotAccelerometerTestResult.value === 0 || entity.iotAedConnectionTestResult.value === 0) {

      return 0;
    } else {
      return 1;
    }
  }

  private checkAllTestColor(testResult, padTestResult) {

    if (testResult === 0) {
      return 'red';
    } else if (padTestResult === 0) {
      return 'orange';
    } else {
      return 'green';
    }
  }


  private checkTestValue(testEntity) {

    if (testEntity.adsTestResult === undefined) {
      testEntity.adsTestResult = 2;
    }
    if (testEntity.ecgTestResult === undefined) {
      testEntity.ecgTestResult = 2;
    }
    if (testEntity.cryptoTestResult === undefined) {
      testEntity.cryptoTestResult = 2;
    }
    if (testEntity.audioTestResult === undefined) {
      testEntity.audioTestResult = 2;
    }
    if (testEntity.padTestResult === undefined) {
      testEntity.padTestResult = 2;
    }
    if (testEntity.chargeCircuit1TestResult === undefined) {
      testEntity.chargeCircuit1TestResult = 2;
    }
    if (testEntity.chargeCircuit2TestResult === undefined) {
      testEntity.chargeCircuit2TestResult = 2;
    }
    if (testEntity.capacitorVoltageTestResult === undefined) {
      testEntity.capacitorVoltageTestResult = 2;
    }
    if (testEntity.hBridgeCircuit1TestResult === undefined) {
      testEntity.hBridgeCircuit1TestResult = 2;
    }
    if (testEntity.hBridgeCircuit2TestResult === undefined) {
      testEntity.hBridgeCircuit2TestResult = 2;
    }
    if (testEntity.onOffButtonTestResult === undefined) {
      testEntity.onOffButtonTestResult = 2;
    }
    if (testEntity.shockButtonTestResult === undefined) {
      testEntity.shockButtonTestResult = 2;
    }
    if (testEntity.iotAccelerometerTestResult === undefined) {
      testEntity.iotAccelerometerTestResult = 2;
    }
    if (testEntity.iotInternalMemoryTestResult === undefined) {
      testEntity.iotInternalMemoryTestResult = 2;
    }
    if (testEntity.iotAedConnectionTestResult === undefined) {
      testEntity.iotAedConnectionTestResult = 2;
    }

    return testEntity;
  }


  private calculateTestType(testType) {

    if (testType === '00') {
      return this.testTypeMap[0];
    } else if (testType === '01') {
      return this.testTypeMap[1];
    } else {
      return this.testTypeMap[2];
    }
  }

  private checkLastTestDate(day, month, year, hour, minute) {
    const lastTestDate = new Date();
    lastTestDate.setDate(day);
    lastTestDate.setMonth(month - 1);
    lastTestDate.setFullYear(year);
    lastTestDate.setHours(hour);
    lastTestDate.setMinutes(minute);
    const today = new Date();
    const validTestDate = new Date(today);
    validTestDate.setDate(today.getDate() - 1);

    if (lastTestDate > validTestDate) {
      this.isLastTestTimeNotValid = false;
    }
  }

  calculateTestResultDescription(testResult, padTestResult) {
    if (testResult === 0) {
      return '0';
    } else if (padTestResult === 0) {
      return '3';
    } else {
      return '1';
    }
  }

  getHealthCaseId(ngsiLdId) {
    const parts = ngsiLdId.split(':');
    return parts[parts.length - 1];
  }

  getCaseDate(caseDate) {
    const dateObject = new Date(caseDate);
    const year = dateObject.getFullYear();
    const month = (dateObject.getMonth() + 1).toString().padStart(2, '0');
    const day = dateObject.getDate().toString().padStart(2, '0');
    return `${day}-${month}-${year}`;
  }

  getCaseTime(caseDate) {
    const dateObject = new Date(caseDate);
    const hours = dateObject.getHours().toString().padStart(2, '0');
    const minutes = dateObject.getMinutes().toString().padStart(2, '0');
    return `${hours}:${minutes}`;
  }

  openTestDialog(defibrillatorTest) {
    this.dialogService.open(DefibrillatorDialogComponent, {
      context: {
        test: defibrillatorTest,
        aselsanUser : this.userService.isAselsanUser()
      }
    });
  }

  openEkgDialog(healthCase, index) {
    this.showSignalQuality = false;
    this.dialogService.open(DefibrillatorEkgDialogComponent, {
      context: {
        healthCaseId: 'urn:ngsi-ld:HealthCase:' + healthCase.healthCaseId,
        healthCaseStartDate: healthCase.observedAt,
        positionStatus: this.positionStatus,
        caseIndex: index,
        cBrokerEndpoint: this.cBrokerEndpoint,
        defibrillatorId: this.defibrillatorId
      }
    }).onClose.subscribe(() => {
      this.showSignalQuality = true;
    });
  }

  handlePadDateSelection(source) {
    this.dialogService.open(DateSelectionDialogComponent, {
      context: {
        showPeriodTab: false,
        dialogSource: source,
        onlyDayTab: true
      }
    });
  }

  get accelerometerStatusSelectValue(): string {
    return this.accelerometerStatus === true ? 'open' : 'closed';
  }

  set accelerometerStatusSelectValue(value: string) {
    this.accelerometerStatus = value === 'open';
    if (this.initialAccelerometerStatus !== this.accelerometerStatus) {
      this.activateUpdateButton();
    }
  }

  updateConfigurations() {
    const updatedData = new DefibrillatorUpdatedData(this.defibrillatorId);
    if (this.adultTempQuery) {
      this.adultPadExpirationDate = this.adultTempQuery.displayText.replace(/\//g, '-').split('-').reverse().join('-');
      updatedData.updatedProperties.push(new DefibrillatorProperty('adultPadExpirationDate', this.adultPadExpirationDate));
    }
    if (this.adultPadExpirationDateDeleted && !this.adultTempQuery) {
      updatedData.updatedProperties.push(new DefibrillatorProperty('adultPadExpirationDate', null));
    }
    if (this.pediatricTempQuery) {
      this.pediatricPadExpirationDate = this.pediatricTempQuery.displayText.replace(/\//g, '-').split('-').reverse().join('-');
      updatedData.updatedProperties.push(new DefibrillatorProperty('pediatricPadExpirationDate', this.pediatricPadExpirationDate));
    }
    if (this.pediatricPadExpirationDateDeleted && !this.pediatricTempQuery) {
      updatedData.updatedProperties.push(new DefibrillatorProperty('pediatricPadExpirationDate', null));
    }
    if (this.guaranteeTempQuery) {
      this.guaranteeStartDate = this.guaranteeTempQuery.displayText.replace(/\//g, '-').split('-').reverse().join('-');
      updatedData.updatedProperties.push(new DefibrillatorProperty('guaranteeStartDate', this.guaranteeStartDate));
    }
    if (this.guaranteeStartDateDeleted && !this.guaranteeTempQuery) {
      updatedData.updatedProperties.push(new DefibrillatorProperty('guaranteeStartDate', null ));
    }
    if (this.initialCompanyName !== this.companyName) {
      updatedData.updatedProperties.push(new DefibrillatorProperty('companyName', this.companyName.split('-')[1]));
    }
    if (this.initialAccelerometerStatus !== this.accelerometerStatus) {
      updatedData.updatedProperties.push(new DefibrillatorProperty('accelerometerStatus', this.accelerometerStatus));
    }
    if (this.initialDescription !== this.description) {
      updatedData.updatedProperties.push(new DefibrillatorProperty('description', this.description));
    }
    this.defibrillatorService.updateDefibrillatorInfo(updatedData).subscribe({
      next: () => {
        this.adultTempQuery = undefined;
        this.pediatricTempQuery = undefined;
        this.guaranteeTempQuery = undefined;
        this.initialCompanyName = this.companyName;
        this.initialAccelerometerStatus = this.accelerometerStatus;
        this.updateButtonStatus = 'passive';
        this.cancelButtonStatus = 'passive';

        const message = 'Configuration settings are updated successfully';
        this.translateService.get([message, 'success']).subscribe(results => {
          this.toastService.show(
            results[message],
            this.translateService.instant('Update'),
            {
              position: NbGlobalPhysicalPosition.TOP_RIGHT,
              status: 'success',
              duration: 5000
            }
          );
        });
      },
      error: () => {
        this.toastService.show(
          this.translateService.instant('Update failed'),
          this.translateService.instant('Error'),
          {
            position: NbGlobalPhysicalPosition.TOP_RIGHT,
            status: 'danger',
            duration: 5000
          }
        );
      }
    });
  }
  activateUpdateButton() {
    this.updateButtonStatus = 'active';
    this.cancelButtonStatus = 'active';
  }
  activateApnUpdateButton() {
    this.updateApnButtonStatus = 'active';
    this.cancelApnButtonStatus = 'active';
  }

  revertChanges() {
    this.adultTempQuery = undefined;
    this.pediatricTempQuery = undefined;
    this.guaranteeTempQuery = undefined;
    this.companyName = this.initialCompanyName;
    this.accelerometerStatus = this.initialAccelerometerStatus;
    this.description = this.initialDescription;
    this.adultPadExpirationDate = this.initialAdultPadExpirationDate;
    this.adultPadExpirationDateDeleted = false;
    this.pediatricPadExpirationDate = this.initialPediatricPadExpirationDate;
    this.pediatricPadExpirationDateDeleted = false;
    this.guaranteeStartDate = this.initialGuaranteeStartDate;
    this.guaranteeStartDateDeleted = false;
    this.updateButtonStatus = 'passive';
    this.cancelButtonStatus = 'passive';
  }

  revertApnChanges() {
    this.simTelNo = this.initialSimTelNo;
    this.apnName = this.initialApnName;
    this.apnUsername = this.initialApnUsername;
    this.apnPassword = this.initialApnPassword;
    this.showApnPasswordVerification = false;
    this.showApnPassword = false;
    this.apnPasswordVerification = '';
    this.updateApnButtonStatus = 'passive';
    this.cancelApnButtonStatus = 'passive';
    this.errors.passwordError = '';
    this.displayErrors = false;
    this.apnPasswordTouched = false;
  }

  onApnPasswordFocus() {
    if (!this.apnPasswordTouched) {
      this.apnPassword = '';
      this.apnPasswordTouched = true;
      this.activateApnUpdateButton();
    }
  }

  validateApnSettings(): boolean {
    this.errors.passwordError = '';
    this.displayErrors = false;
    if (this.apnPasswordVerification !== this.apnPassword) {
      this.displayErrors = true;
      this.errors.passwordError = 'Passwords do not match!';
    }
    return !this.errors.passwordError;
  }

  updateApnSettings() {
    const updatedData = new DefibrillatorUpdatedData(this.defibrillatorId);
    if (this.initialSimTelNo !== this.simTelNo) {
      updatedData.updatedProperties.push(new DefibrillatorProperty('simTelNo', this.simTelNo));
    }
    if (this.initialApnName !== this.apnName) {
      updatedData.updatedProperties.push(new DefibrillatorProperty('apnName', this.apnName));
    }
    if (this.initialApnUsername !== this.apnUsername) {
      updatedData.updatedProperties.push(new DefibrillatorProperty('apnUser', this.apnUsername));
    }
    if (this.initialApnPassword !== this.apnPassword) {
      updatedData.updatedProperties.push(new DefibrillatorProperty('apnPassword', this.apnPassword));
    }
    if (!this.validateApnSettings()) {
      return;
    }

    const dialogRef = this.dialogService.open(GenericConfirmationDialogComponent, {
      context: {
        title: this.translateService.instant('Update APN Settings'),
        body: this.translateService.instant('Are you sure you want to update APN settings?'),
        leftButtonText: 'Cancel',
        rightButtonText: 'Update',
        leftButtonStyle: 'btn btn-secondary cancel-button',
        rightButtonStyle: 'btn btn-primary delete-button'
      }
    });

    dialogRef.onClose
      .pipe(takeUntil(this.destroy$))
      .subscribe(result => {
        if (result) {
          this.defibrillatorService.updateDefibrillatorInfo(updatedData).subscribe({
            next: () => {
            this.initialSimTelNo = this.simTelNo;
            this.initialApnName = this.apnName;
            this.initialApnUsername = this.apnUsername;
            this.initialApnPassword = this.apnPassword;
            this.initialApnPasswordVerification = '';
            const message = 'APN settings are updated successfully';
            this.translateService.get([message, 'success']).subscribe(results => {
              this.toastService.show(
                results[message],
                this.translateService.instant('Update'),
                {position: NbGlobalPhysicalPosition.TOP_RIGHT, status: 'success', duration: 5000});
            });
            this.revertApnChanges();
            },
            error: () => {
              this.toastService.show(
                this.translateService.instant('Update failed'),
                this.translateService.instant('Error'),
                {
                  position: NbGlobalPhysicalPosition.TOP_RIGHT,
                  status: 'danger',
                  duration: 5000
                }
              );
            }
          });
        }
      });
  }

  deleteGuaranteeDate() {
    this.guaranteeStartDate = undefined;
    this.guaranteeTempQuery = undefined;
    this.guaranteeStartDateDeleted = true;
    this.activateUpdateButton();
  }

  deleteAdultPadExpirationDate() {
    this.adultPadExpirationDate = undefined;
    this.adultTempQuery = undefined;
    this.adultPadExpirationDateDeleted = true;
    this.activateUpdateButton();
  }

  deletePediatricPadExpirationDate() {
    this.pediatricPadExpirationDate = undefined;
    this.pediatricTempQuery = undefined;
    this.pediatricPadExpirationDateDeleted = true;
    this.activateUpdateButton();
  }

  togglePasswordVisibility() {
    this.showApnPassword = !this.showApnPassword;
  }

  togglePasswordVerificationVisibility() {
    this.showApnPasswordVerification = !this.showApnPasswordVerification;
  }
}
